// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Urad","col":"styles_col__3b0ej"};